/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type NotificationContainer_viewer = {
    readonly lastSeenNotificationDate: string | null;
    readonly " $refType": "NotificationContainer_viewer";
};
export type NotificationContainer_viewer$data = NotificationContainer_viewer;
export type NotificationContainer_viewer$key = {
    readonly " $data"?: NotificationContainer_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"NotificationContainer_viewer">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "NotificationContainer_viewer",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastSeenNotificationDate",
            "storageKey": null
        }
    ],
    "type": "User",
    "abstractKey": null
} as any);
(node as any).hash = '34c997ee1756dd689e154ef0c7ea6213';
export default node;
